import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { getRecentlyViewed } from "@/lib/recentlyViewed";
import { Clock } from "lucide-react";

// A horizontal strip of the shopper's recently-viewed listings.
// Reads ids from localStorage, hydrates them via /listings/by-ids, and renders nothing when empty.
export default function RecentlyViewed({
  excludeId,
  className = "",
  eyebrow = "Pick up where you left off",
  title = "Recently viewed",
}) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const ids = getRecentlyViewed(excludeId);
    if (!ids.length) { setItems([]); return; }
    api.get("/listings/by-ids", { params: { ids: ids.join(",") } })
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, [excludeId]);

  if (!items.length) return null;

  return (
    <section className={`max-w-[1600px] mx-auto px-6 lg:px-12 ${className}`} data-testid="recently-viewed">
      <div className="mb-6">
        <div className="label-eyebrow inline-flex items-center gap-1.5" style={{ color: "#2563EB" }}>
          <Clock size={13} /> {eyebrow}
        </div>
        <h2 className="font-display text-3xl md:text-4xl tracking-tight mt-2">{title}</h2>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-3 -mx-1 px-1 snap-x" data-testid="recently-viewed-row">
        {items.map((it) => (
          <div key={it.id} className="w-40 sm:w-48 md:w-52 shrink-0 snap-start"
            data-testid={`recent-card-${it.id}`}>
            <ProductCard item={it} />
          </div>
        ))}
      </div>
    </section>
  );
}
